import { createSelector } from '@reduxjs/toolkit';
import orderBy from 'lodash/orderBy';
import uniqBy from 'lodash/uniqBy';
import moment from 'moment-timezone';

import { IAbsenceType } from 'src/api/dtos';
import { DATE_FORMAT } from 'src/shared/constants';
import { RootState } from 'src/store/types';

const selectSelf = (state: RootState) => state.absences;

export const getUniqueAbsenceTypes = createSelector(selectSelf, ({ types }) => {
  return uniqBy<IAbsenceType>(types, 'id');
});

export const getAbsenceTypesByPartialCheck = (isPartialDay: boolean) =>
  createSelector(selectSelf, ({ types }) => {
    return types.filter((type) => type.isPartialDay === isPartialDay);
  });

export const getAbsencesDateRangesValue = createSelector(selectSelf, ({ data }): string => {
  if (!data.length) {
    return '';
  }

  const [oldest] = orderBy(data, ['startDate'], ['asc']);
  const [latest] = orderBy(data, ['startDate'], ['desc']);

  const today = moment();
  const todayString = today.format(DATE_FORMAT);

  if (!oldest && !latest) {
    return todayString;
  }

  const oldestString =
    oldest && !today.isSame(oldest.startDate, 'day') ? moment(oldest.startDate).format(DATE_FORMAT) : undefined;
  const latestString =
    latest && !today.isSame(latest.startDate, 'day') ? moment(latest.startDate).format(DATE_FORMAT) : undefined;

  if (!oldestString && !latestString) {
    return todayString;
  }

  if (oldestString === latestString) {
    return oldestString || latestString || todayString;
  }

  return `${oldestString || todayString} - ${latestString || todayString}`;
});
